export default "__VITE_ASSET__DU$QhDHX__"